<div class="p-6 space-y-6" id="page-tareas">
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h2 class="text-xl font-bold text-gray-900 dark:text-white">Tareas del Proyecto</h2>
      <p class="text-sm text-gray-400 dark:text-gray-500">Licencia Construcción Lote 14 · Constructora Azteca S.A.</p>
    </div>
    <button type="button" class="btn btn-primary gap-2 w-full sm:w-auto">
      <svg class="w-4 h-4"><use href="/svg/sprite.svg#plus-sign"/></svg>
      Nueva Tarea
    </button>
  </div>

  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800 overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-100 dark:border-gray-800 flex flex-col lg:flex-row gap-3">
      <label class="input w-full lg:flex-1">
        <svg class="w-4 h-4 opacity-50"><use href="/svg/sprite.svg#search-icon"/></svg>
        <input type="text" placeholder="Buscar tarea o responsable..." class="grow" />
      </label>
      <select class="select w-full sm:w-auto">
        <option>Estado: Todos</option>
        <option>Completada</option>
        <option>En proceso</option>
        <option>Pendiente</option>
        <option>Por iniciar</option>
        <option>Bloqueada</option>
      </select>
      <select class="select w-full sm:w-auto">
        <option>Responsable: Todos</option>
        <option>Lic. Carlos Méndez</option>
        <option>Arq. Laura Sánchez</option>
        <option>Ing. Pedro Rojas</option>
      </select>
    </div>
  </div>

  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800
            overflow-hidden">
    <div class="px-4 sm:px-6 py-4 border-b border-gray-100 dark:border-gray-800 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <h3 class="text-base font-bold text-gray-800 dark:text-white">Diagrama de Gantt — Noviembre 2024</h3>
      <span class="badge badge-outline border-orange-200 text-orange-600 dark:border-orange-900/40 dark:text-orange-400">Vista mensual</span>
    </div>
    <div class="overflow-x-auto">
      <div class="min-w-175 p-4">
        <div class="mb-2 flex">
          <div class="w-56 shrink-0"></div>
          <div class="flex-1 grid grid-cols-30 gap-0">
            <div class="justify-between px-1 flex">
              <span class="text-xs text-gray-400">1</span>
              <span class="text-xs text-gray-400">5</span>
              <span class="text-xs text-gray-400">10</span>
              <span class="text-xs text-gray-400">15</span>
              <span class="text-xs text-gray-400">20</span>
              <span class="text-xs text-gray-400">25</span>
              <span class="text-xs text-gray-400">30</span>
            </div>
          </div>
        </div>
        <div class="items-center mb-2 flex group">
          <div class="w-56 pr-4 shrink-0">
            <p class="text-xs font-semibold text-gray-700 dark:text-gray-300 truncate">Solicitud de documentos</p>
            <p class="text-xs text-gray-400">Completada</p>
          </div>
          <div class="bg-gray-100 dark:bg-gray-800 rounded-full h-6 flex-1 relative">
            <div style="width: 40%;" class="h-6 rounded-full bg-linear-to-r items-center px-2 absolute left-0
                      from-green-500 to-green-400 flex">
              <span class="text-xs text-white font-medium">1-12 Nov</span>
            </div>
          </div>
          <div class="ml-2 flex gap-1 opacity-0 group-hover:opacity-100 transition">
            <button type="button" class="btn btn-ghost btn-square btn-xs">
              <svg class="w-3 h-3"><use href="/svg/sprite.svg#pencil-icon"/></svg>
            </button>
          </div>
        </div>
        <!-- Additional Gantt rows follow with similar structure -->
      </div>
    </div>
    <div class="px-4 sm:px-6 py-3 border-t border-gray-100 dark:border-gray-800 flex flex-wrap gap-4">
      <span class="items-center text-xs text-gray-500 flex gap-1.5">
        <span class="w-3 h-3 bg-green-400 rounded inline-block"></span>
        Completada
      </span>
      <span class="items-center text-xs text-gray-500 flex gap-1.5">
        <span class="w-3 h-3 bg-orange-400 rounded inline-block"></span>
        En proceso
      </span>
      <span class="items-center text-xs text-gray-500 flex gap-1.5">
        <span class="w-3 h-3 bg-blue-400 rounded inline-block"></span>
        Pendiente
      </span>
      <span class="items-center text-xs text-gray-500 flex gap-1.5">
        <span class="w-3 h-3 bg-yellow-400 rounded inline-block"></span>
        Por iniciar
      </span>
      <span class="items-center text-xs text-gray-500 flex gap-1.5">
        <span class="w-3 h-3 bg-red-400 rounded inline-block"></span>
        Bloqueada
      </span>
    </div>
  </div>
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-800
            overflow-hidden">
    <div class="flex flex-col gap-3 px-4 sm:px-6 py-4 border-b border-gray-100 dark:border-gray-800 sm:flex-row sm:items-center sm:justify-between">
      <h3 class="text-base font-bold text-gray-800 dark:text-white">Lista de Tareas</h3>
      <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-0.5 rounded-lg font-medium w-fit
                dark:text-orange-400">5 tareas</span>
    </div>
    <div class="divide-y divide-gray-50 dark:divide-gray-800">
      <div class="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="w-8 h-8 rounded-xl bg-green-100 dark:bg-green-900/30 items-center justify-center shrink-0 flex">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_7e4BPrfgR"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-800 dark:text-gray-200">Solicitud de documentos</p>
          <p class="text-xs text-gray-400">Lic. Carlos Méndez · 1-12 Nov 2024</p>
        </div>
        <span class="text-xs bg-green-100 dark:bg-green-900/30 text-green-600 px-2 py-0.5 rounded-lg font-medium shrink-0
                dark:text-green-400">Completada</span>
      </div>
      <div class="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="w-8 h-8 rounded-xl bg-orange-100 dark:bg-orange-900/30 items-center justify-center shrink-0 flex">
          <svg class="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_soxfQW4Kf"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-800 dark:text-gray-200">Revisión predial</p>
          <p class="text-xs text-gray-400">Arq. Laura Sánchez · 8-19 Nov 2024</p>
        </div>
        <span class="text-xs bg-orange-100 dark:bg-orange-900/30 text-orange-600 px-2 py-0.5 rounded-lg shrink-0
                font-medium dark:text-orange-400">En proceso</span>
      </div>
      <div class="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="w-8 h-8 rounded-xl bg-blue-100 dark:bg-blue-900/30 items-center justify-center shrink-0 flex">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_h0lvhHmLz"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-800 dark:text-gray-200">Ingreso de planos</p>
          <p class="text-xs text-gray-400">Ing. Pedro Rojas · 17-26 Nov 2024</p>
        </div>
        <span class="text-xs bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-2 py-0.5 rounded-lg font-medium shrink-0
                dark:text-blue-400">Pendiente</span>
      </div>
      <div class="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="w-8 h-8 rounded-xl bg-yellow-100 dark:bg-yellow-900/30 items-center justify-center shrink-0 flex">
          <svg class="w-4 h-4 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_rgZ7dRGf7"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-800 dark:text-gray-200">Dictamen técnico</p>
          <p class="text-xs text-gray-400">Ing. Pedro Rojas · 22-30 Nov 2024</p>
        </div>
        <span class="text-xs bg-yellow-100 dark:bg-yellow-900/30 text-yellow-600 px-2 py-0.5 rounded-lg shrink-0
                font-medium dark:text-yellow-400">Por iniciar</span>
      </div>
      <div class="flex items-center gap-3 px-4 sm:px-6 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition">
        <div class="w-8 h-8 rounded-xl bg-red-100 dark:bg-red-900/30 items-center justify-center shrink-0 flex">
          <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" id="Windframe_IgT298WeF"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-800 dark:text-gray-200">Entrega de licencia</p>
          <p class="text-xs text-gray-400">Lic. Carlos Méndez · 30 Nov 2024</p>
        </div>
        <span class="text-xs bg-red-100 dark:bg-red-900/30 text-red-600 px-2 py-0.5 rounded-lg font-medium shrink-0
                dark:text-red-400">Bloqueada</span>
      </div>
    </div>
  </div>
</div>

